// extracted by mini-css-extract-plugin
export default {"container":"container_PidWo","headerDescription":"headerDescription_s9Cb1","agents":"agents_AAcIC","isBottomRoundings":"isBottomRoundings_venRz"};